const objectMap = (obj, mappingFn) =>
  Object.assign(
    {},
    ...Object.keys(obj).map(key => ({
      [key]: mappingFn(obj[key])
    }))
  );

export const encodeParam = param => encodeURIComponent(param);
export const decodeParam = param => decodeURIComponent(param);

export const encodeParams = params => objectMap(params, encodeParam);
export const decodeParams = params => objectMap(params, decodeParam);



// WEBPACK FOOTER //
// ./src/react-router-utils/encoder.js